export const hotkey_keyword_shift = "yXb";
export const hotkey_keyword_ctrl = "zXb";
export const hotkey_keyword_alt = "AXb";
export const hotkey_keyword_meta = "BXb";
export const hotkey_keyword_backspace = "CXb";
export const hotkey_keyword_tab = "DXb";
export const hotkey_keyword_enter = "EXb";
export const hotkey_keyword_return = "FXb";
export const hotkey_keyword_capslock = "GXb";
export const hotkey_keyword_esc = "HXb";
export const hotkey_keyword_escape = "IXb";
export const hotkey_keyword_space = "JXb";
export const hotkey_keyword_pageup = "KXb";
export const hotkey_keyword_pagedown = "LXb";
export const hotkey_keyword_end = "MXb";
export const hotkey_keyword_home = "NXb";
export const hotkey_keyword_left = "OXb";
export const hotkey_keyword_up = "PXb";
export const hotkey_keyword_right = "QXb";
export const hotkey_keyword_down = "RXb";
export const hotkey_keyword_ins = "SXb";
export const hotkey_keyword_del = "TXb";
export const hotkey_keyword_command = "UXb";
export const hotkey_keyword_plus = "VXb";
export const keyboardShortcutThen = "WXb";
export default {hotkey_keyword_shift,hotkey_keyword_ctrl,hotkey_keyword_alt,hotkey_keyword_meta,hotkey_keyword_backspace,hotkey_keyword_tab,hotkey_keyword_enter,hotkey_keyword_return,hotkey_keyword_capslock,hotkey_keyword_esc,hotkey_keyword_escape,hotkey_keyword_space,hotkey_keyword_pageup,hotkey_keyword_pagedown,hotkey_keyword_end,hotkey_keyword_home,hotkey_keyword_left,hotkey_keyword_up,hotkey_keyword_right,hotkey_keyword_down,hotkey_keyword_ins,hotkey_keyword_del,hotkey_keyword_command,hotkey_keyword_plus,keyboardShortcutThen};